import { logger } from "@/utils/logger";
// 服务层统一导出

// 基础服务
import { apiService } from "./api";
import wsService from "./websocket";
export { apiService, type ApiResponse, type RequestConfig } from "./api";
export type { PageResponse } from "@/types/api";
export {
  default as wsService,
  useWebSocketData,
  type WSMessage,
  type DataCallback,
} from "./websocket";

// 业务服务
import { tradingService } from "./trading";
import { riskService } from "./risk";
import { marketService } from "./market";
import { userService } from "./user";
import { notificationService } from "./notification";
import { basicInfoService } from "./basicInfo";
export {
  tradingService,
  type TradingOrder,
  type Position,
  type AccountInfo,
  type CreateOrderRequest,
} from "./trading";
export {
  riskService,
  type RiskMetrics,
  type RiskLimit,
  type RiskAlert,
  type MarginInfo,
} from "./risk";
export { marketService, type MarketTicker, type Kline, type OrderBook, type Trade } from "./market";
export { userService, type UserInfo, type UserPreferences, type LoginResponse } from "./user";
export {
  basicInfoService,
  type TraderInfo,
  type FundInfo,
  type FutureETFTickerData as FutureETFTicker,
  type BasicInfoData,
} from "./basicInfo";

// 通知服务
export {
  notificationService,
  notifySuccess,
  notifyWarning,
  notifyInfo,
  notifyError,
  showMessage,
  confirmDialog,
  alertDialog,
  promptDialog,
  NotificationType,
  type NotificationMessage,
  type SystemNotification,
} from "./notification";

// PCP主品种基差配置服务
export {
  fetchBasisTargetMain,
  upsertBasisTargetMain,
  replaceBasisTargetMain,
  type BasisTargetMainEntry,
  type BasisTargetMainQuery,
} from "./pcpBasisTargetMain";

/**
 * 服务初始化
 */
export function initServices() {
  logger.log("初始化服务层...");

  // 不在这里初始化WebSocket，应该在用户登录后手动调用
  // WebSocket连接应该在用户认证成功后建立

  logger.log("服务层初始化完成");
}

/**
 * 服务清理
 */
export function cleanupServices() {
  logger.log("清理服务层资源...");

  // 断开WebSocket连接
  wsService.disconnect();

  logger.log("服务层资源清理完成");
}

// 默认导出主要服务
export default {
  api: apiService,
  ws: wsService,
  trading: tradingService,
  risk: riskService,
  market: marketService,
  user: userService,
  notification: notificationService,
  basicInfo: basicInfoService,
};
